import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";
import useConstants from "@hooks/useConstants";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import shortid from "shortid";
import BoxTile from "@components/Global/Custom/BoxTile";
import Link from "@material-ui/core/Link";

const CostsList = () => {
	const classes = useStyles("Costs");
	const { costGuideStore: store } = useStores();
	const { showThumbsCost } = useConstants("CostsViewModel");
	return (
		<Box
			component="section"
			minHeight={400}
			width="100%"
			pt={10}
			pb={12}
			pr={2}
			pl={2}
		>
			<Container maxWidth="md">
				{Object.keys(store.groupedCostGuides).map((serviceNameProper, i) => (
					<Box mb={16} key={`groupedCostGuide-${i}`}>
						<Box mb={8}>
							<Box
								component="h2"
								fontSize={{ xs: 22, sm: 24 }}
								fontWeight={700}
								lineHeight={"30px"}
								mt={0}
								mb={0}
							>
								{serviceNameProper.ucFirst()} costs
							</Box>
						</Box>
						{showThumbsCost ? (
							<div>
								<Grid container spacing={4}>
									{store.groupedCostGuides[serviceNameProper].map(
										(costGuide, i) => (
											<BoxTile
												key={`costGuide-${i}`}
												title={`${costGuide.name}`}
												src={costGuide.thumbnail?.cdnUrl}
												link={`${costGuide.folder}${costGuide.slug}`}
											/>
										)
									)}
								</Grid>
							</div>
						) : (
							<div>
								<Grid container spacing={4}>
									{store.groupedCostGuides[serviceNameProper].map(
										(costGuide, i) => (
											<Grid item xs={12} sm={6} md={4}>
												<Link
													color={"secondary"}
													href={`${costGuide.folder}${costGuide.slug}`}
													key={`costGuide-${i}`}
												>
													{`${costGuide.name}`}
												</Link>
											</Grid>
										)
									)}
								</Grid>
							</div>
						)}
					</Box>
				))}
			</Container>
		</Box>
	);
};

CostsList.propTypes = {};
export default CostsList;
